/**
 * Named gesture-tuning presets for Melodimals.
 *
 * Centralising the magic numbers keeps the feel consistent across call sites and
 * makes tuning a one-line change. Each preset bundles the recognizer's
 * `fling`/`thresholdPx` with the consumer-facing layout constants (commit
 * thresholds, animation durations) that the recognizer itself does not own.
 */

import type { FlingConfig } from "./types";

const GESTURE_DEADZONE_PX = 8;

/**
 * Song-player carousel: horizontal swipe to glide to the previous/next song.
 *
 * Tuned for small hands: a forgiving fling (short, fast flicks count) plus a
 * low absolute commit threshold capped by a fraction of the stage width, so a
 * confident half-swipe always lands. Non-destructive — only navigation.
 */
export const SONG_CAROUSEL = {
  thresholdPx: GESTURE_DEADZONE_PX,
  /** Commit at the smaller of a fixed travel or a fraction of the stage width. */
  commitThresholdPx: 64,
  commitThresholdRatio: 0.22,
  transitionMs: 260,
  fallbackWidthPx: 360,
  hapticMs: 14,
  fling: { maxDurationMs: 320, minDistancePx: 45, axisRatio: 2 } satisfies FlingConfig,
} as const;
